import React, { useState, useEffect } from 'react'
import styles from './SearchBar.module.scss'

const SearchBar = ({ onSearch, placeholder = "Поиск фильмов..." }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [isFocused, setIsFocused] = useState(false)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchTerm.length >= 2 || searchTerm.length === 0) {
        onSearch(searchTerm)
      }
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [searchTerm, onSearch])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSearch(searchTerm)
  }

  const clearSearch = () => {
    setSearchTerm('')
    onSearch('')
  }

  return (
    <form onSubmit={handleSubmit} className={styles.searchForm}>
      <div className={`${styles.searchContainer} ${isFocused ? styles.focused : ''}`}>
        <div className={styles.searchIcon}>🔍</div>
        
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className={styles.searchInput}
        />
        
        {searchTerm && (
          <button
            type="button"
            onClick={clearSearch}
            className={styles.clearButton}
          >
            ✕
          </button>
        )}
      </div>
    </form>
  )
}

export default SearchBar